import { FormControlLabel, Switch } from "@mui/material"

const LabelledSwitch = (props) => {
    const { id, index, onChange, checked, label, disabled } = props;

    const _onChange = (evt) => {
        const value = evt.target.checked;
        onChange(id, value, true);
    }

    return <FormControlLabel
        control={<Switch
            index={index}
            checked={checked}
            onChange={_onChange}
            disabled={disabled}
            inputProps={{ 'aria-label': 'controlled' }}
        />}
        label={label}
        labelPlacement="end"
    />
}

export default LabelledSwitch;